<ng-container *ngIf="['WAITING', 'PREPARATION', 'READY', 'COLLECTED'].includes(order?.status)">
  <div class="md:flex md:flex-col md:items-center kiosk:mt-32">
    <div class="px-5 pb-3 md:w-8/12">
      <div class="flex items-center md:justify-center pb-3 pt-1 pl-5 pr-11">
        <p
          class="text-accent text-2xl md:text-5xl kiosk:text-6xl font-bold mr-6 md:mr-7 leading-8"
          [style.color]="textColor | contentBuilderColor"
        >
          {{ text }}
        </p>
        <span class="kiosk:hidden"
          ><i class="icon icon-n-check text-success-600 text-4xl md:text-5.8xl"></i
        ></span>
      </div>
    </div>
  </div>
</ng-container>
